import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/version';
import { ENV_SETTINGS } from '../../constants';
import DashCard from './DashCard';


class VersionCard extends React.Component {
    constructor(props) {
        super(props);

        this.getAllVersions = this.getAllVersions.bind(this);
    }

    getAllVersions() {
        this.props.getVersion('US');
        this.props.getVersion('EU');
        this.props.getVersion('GBL');
        this.props.getVersion('MICROSOFT');
        this.props.getVersion('DEV');
        this.props.getVersion('DEV2');
        this.props.getVersion('SANDBOX');
    }

    componentDidMount() {
        this.getAllVersions();

        this.versionInterval = setInterval(this.getAllVersions, 30 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.versionInterval);
    }

    render() {
        return (
            <DashCard title="Versions" className="card version-card">
                <div className="version-prod">
                    <div className="version-item">
                        {[
                            ENV_SETTINGS.US,
                            ENV_SETTINGS.EU,
                        ].map((settings, index) => (
                            <div key={index}>
                                <img
                                    className="version-item__logo"
                                    src={settings.icon}
                                    alt="logo"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="version-item">
                        {[
                            ENV_SETTINGS.US,
                            ENV_SETTINGS.EU,
                        ].map((settings, index) => (
                            <div key={index}>
                                <span className="version-item__number">
                                    {this.props[settings.name]}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="version-item">
                        {[
                            ENV_SETTINGS.GBL,
                            ENV_SETTINGS.MICROSOFT,
                        ].map((settings, index) => (
                            <div key={index}>
                                <img
                                    className="version-item__logo"
                                    src={settings.icon}
                                    alt="logo"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="version-item">
                        {[
                            ENV_SETTINGS.GBL,
                            ENV_SETTINGS.MICROSOFT,
                        ].map((settings, index) => (
                            <div key={index}>
                                <span className="version-item__number">
                                    {this.props[settings.name]}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="version-dev">
                    <div className="card-title">
                        <span>Version dev</span>
                    </div>

                    {[
                        ENV_SETTINGS.DEV,
                        ENV_SETTINGS.DEV2,
                        ENV_SETTINGS.SANDBOX,
                    ].map((settings, index) => (
                        <div key={index}>
                            <img
                                className="version-item__logo"
                                src={settings.icon}
                                alt="logo"
                            />
                            <span className="version-item__number">
                                {this.props[settings.name]}
                            </span>
                        </div>
                    ))}
                </div>
            </DashCard>
        );
    }
}

const mapStateToProps = ({ version }) => version;

export default connect(
    mapStateToProps,
    actions
)(VersionCard);



// WEBPACK FOOTER //
// ./src/components/Cards/VersionCard.js